export default "__VITE_ASSET__CchEeXqb__"